import React from 'react';
import AbstractTopicComponent from './AbstractTopicComponent';
import HmEventRegistry from '../../model/HmEventRegistry';
import HmAjax from '../../util/HmAjax';

class ContestTopicComponent extends AbstractTopicComponent {
	
  constructor(props) {
	  super(props);  
	  this.state={
		gifAnimSrc:'',
		gifSrc: '',
		imgSrc: '',
		boxColor: ''
		}
	this.onTopicStart = this.onTopicStart.bind(this);  	
	this.handleMouseOver = this.handleMouseOver.bind(this);
	this.handleMouseOut = this.handleMouseOut.bind(this);
}
  
componentDidMount(){	
    //console.log("selectedGrade::"+this.props.selectedGradeLabel);
    let boxDefaultColor = "#ee3d45";
    let boxDefaultImg = "box_default.png";
    
      let boxcolor = boxDefaultColor;
      let boxImgSrc = require("../../images/animations/"+boxDefaultImg);
      let boxgifsrc = require("../../images/animations/"+boxDefaultImg);
      

      //console.log("lalala: topic::",this.props.topic);

      if(this.props.topic.staticImgPath && this.props.topic.staticImgPath != ""){
          boxImgSrc = this.props.topic.staticImgPath;
      }
      if(this.props.topic.animatedImgPath && this.props.topic.animatedImgPath != ""){
          boxgifsrc = this.props.topic.animatedImgPath;
      }
      if(this.props.topic.colourCode && this.props.topic.colourCode != ""){
          boxcolor = this.props.topic.colourCode;
      }
      this.setState({
            imgSrc: boxImgSrc,
            gifAnimSrc:boxgifsrc,
                gifSrc: boxImgSrc,
                boxColor: boxcolor
          });
      
      
	  HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
}

  onTopicStart(){
	let viewSolution =  this.viewSolution();
	if(viewSolution){
		this.getViewSolution()
	}
	else if(this.props.topic && this.props.topic.testAvailable && this.props.topic.contestAvailable){
		let TestDetails = {
			contestId:this.props.topic.contestId || 0,
			roundTestId:this.props.topic.roundTestId || 0,
			userTestDetails:this.props.topic.userTestDetails || {},
			testDefn:this.props.topic.testDefn || {}
		}
		this.props.callbackParent(TestDetails);
	}
  }

  handleMouseOver() {
    this.setState({
      imgSrc: this.state.gifAnimSrc
    });    
  }

  handleMouseOut() {
    this.setState({
    	 imgSrc: this.state.gifSrc
    });
    
  }

  getTestsActionLabel(){
	let topicStatus = this.props.topic.userTestDetails.status || 'NEW';
	  	switch (topicStatus) {
	      case "COMPLETED":   return this.rb("home.revise");
		  case "IN_PROGRESS":return this.rb("home.resume");
		  case "NEW": return this.rb("home.resume");
          default: return this.rb("home.start");
	    }
  }
  
  getContestQuestion = (roundTestId = 0) => {
	let me=this;
	var success =  function(response){
		if(response !==null){
			if(response.status === "success"){
				console.warn("SHOW_SOLUTION ",response);
				let solutionData = (response.data) ? response.data : null;
				HmEventRegistry.fireEvent("SHOW_SOLUTION",solutionData);
			}
		}
	}
	var failure =  function(response){
		
	}
	new HmAjax(this.getUrlFor("GET_VIEW_SOLUTION").replace("{#contestId}",this.getContestHost()).replace("{#roundTestId}",roundTestId)).mask().get(success, failure);
}


 	getViewSolution = () => {
	    let roundTestId = this.props.topic.roundTestId;
		this.getContestQuestion(roundTestId);
	}

  topicLocked(){
	let locked = !this.props.topic.testAvailable ? true : false;
	return locked;
  }

  viewSolution = () => {
	let solutionEnabled = (this.props.topic.solutionEnabled) ? true : false;
	return solutionEnabled;
  }

  topicCompleted(){
	let topicComplete = this.props.topic.userTestDetails.status==="COMPLETED" ? true : false;
	return topicComplete;
  }

  getTopicBottomSection(){
       let me = this;
       
	let topicStatus = me.props.topic.userTestDetails.status || 'UN_ATTEMPTED';
	let gradeName = me.props.roundName || '';
	let topicName = this.props.topic.testDefn.title || '';
	//let testAvailable = (topicStatus === "COMPLETED") ? false : true;
	let testCompleted = me.topicCompleted();
	let testbtnLocked = "";
	let testLocked = me.topicLocked();
	
	if(testCompleted || testLocked){
		testbtnLocked="disabled";
	}

	return(
		<div className="card-body card-bottom">			      		    
			<span className="card-link user-points">
				{/* <img className="bottomPointsIcon" src={bottomPointsIcon} />
				<span className="user-points">{this.getUserTopicPoints()}</span>
					/ 
				<span className="points">{this.getTopicPoints()}</span> */}
			</span>
			<div className={"card-link float-right tileLink"} data-ga={"Student - " +topicStatus+ " - " + this.props.topic.testDefn.title}>
			{/* <div className={"card-link float-right tileLink showcursor "+testbtnLocked} data-ga={"Student - " +topicStatus+ " - " + this.props.topic.testDefn.title}>		    		    	 */}
					<h5>
						{(() => {
						if(me.viewSolution() === true){
							return this.rb("topic.viewsolution");
						}
						if(me.topicLocked() === true){
							return this.rb("topic.locked");
						}

						switch (topicStatus) {
							case "COMPLETED":   return this.rb("home.completed");
							case "IN_PROGRESS": return this.rb("home.resume");
							case "NEW": return this.rb("home.resume");
							default:      return this.rb("home.start");
						}
						})()}
					</h5>
				</div>
		</div>
		);
  }


  getTestAvailableStatusFn(){
	  let me=this;
	  let viewSolution =  me.viewSolution();
	if(!viewSolution && this.props.topic && this.props.topic.lockingReason && this.props.topic.lockTime){
		return (
			<div className="testLocking">
				{me.rb(me.props.topic.lockingReason)} <span>{me.epochTimeFn(me.props.topic.lockTime)},&nbsp;</span><span>{me.formatAMPM(me.props.topic.lockTime)}</span>
			</div>
		)
	}
  }
  
  render() {
        let me=this;
	  let topicStatus = this.props.topic.userTestDetails.status || 'NEW';
	  //let lessonOnlyMode = this.props.lessonOnlyMode  || false;
	  let selectedGradeLabel  = this.props.roundName || 'contest';
	  let topicDescription =  this.props.topic.testDefn.description || '';
	  let topicName = this.props.topic.testDefn.title || '';
	  let testAvailable = this.props.topic.testAvailable || false;
	  let boxColor = this.state.boxColor ;
	  let benchmarkAvailable = this.props.topic.benchmarkAvailable || false;

	  if(benchmarkAvailable){
		boxColor = "#0280ba"
	  }

	  let testlock = "testLock";

	  if(testAvailable){
		testlock = "testOpen";
	  }

	  let testCompleted = me.topicCompleted();
		let testbtnLocked = "";
		let testLocked = me.topicLocked();
		let viewSolution =  me.viewSolution();

		if(viewSolution){
			testbtnLocked="";
			testlock = "testOpen";
		}
		else if((testCompleted || testLocked)){
			testbtnLocked=" disabled";
		}
      
    return (  
		<div className={"card "+selectedGradeLabel+" showcursor"+testbtnLocked} onClick={this.onTopicStart}>
			<div className="card-img-top topic text-center" style={{backgroundColor: boxColor}} onMouseOver={this.handleMouseOver} onMouseOut={this.handleMouseOut}>
				<img className={"bgimg animgif " + ((topicStatus === "COMPLETED") ? 'opacityInGif' : '')} src={this.state.imgSrc} />
				{(() => {
					if(topicStatus === "COMPLETED") {
						// if(lessonOnlyMode == false){
						// 	return <img className="topiccompletedIcon" src={completedTickImg} />;				    		       
						// }
					}
					})()}
				
				
			</div>
				<div className={"card-img-overlay "+testlock}>

				<div className="card-title">{topicName}</div>	

				{this.getTestAvailableStatusFn()}	    			    
				</div>
				
				

				<div className="card-body descBody">	    		   
				<p className="card-text">{topicDescription}</p>
				</div>    
				
			{this.getTopicBottomSection()}
			
		</div>
    );
  }
}

export default ContestTopicComponent;



// WEBPACK FOOTER //
// ./src/views/plp/ContestTopicComponent.js